import axios from "axios"
import { Formik, FormikHelpers } from "formik"
import {
  Alert,
  Button, Form,
  Modal
} from "react-bootstrap"
import * as yup from "yup"

export const ModalWithInput = function (
  show: boolean,
  name: string,
  modalHeading: string,
  labelName: string,
  saveHandler: (newName: string) => Promise<void>,
  closeHandler: () => void
) {
  const validationSchema = yup.object().shape({
    newName: yup.string().required("Name is required."),
  })

  return (
    <Modal show={show} onHide={closeHandler} key={modalHeading + name}>
      <Modal.Header closeButton>
        <Modal.Title>{modalHeading}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          validationSchema={validationSchema}
          initialValues={{ newName: name }}
          onSubmit={async (
            values: {
              newName: string
            },
            {
              setSubmitting, setStatus,
            }: FormikHelpers<{
              newName: string
            }>
          ) => {
            try {
              // Pass the updated name to the parent component
              await saveHandler(values.newName)
              closeHandler()
            } catch (err) {
              // alert(err)
              // console.log(err)
              let errMsg = "Unexpected error"
              if (axios.isAxiosError(err)) {
                errMsg = err.response?.data
              } else if (err) {
                errMsg = err.toString()
              }
              setStatus(`${errMsg}. Please try again.`)
            } finally {
              setSubmitting(false)
            }
          }}
        >
          {({
            handleSubmit, handleChange, values, errors, touched, isSubmitting, status,
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Label
                htmlFor="modalInput"
                style={{ width: "100%", display: "block" }}
              >
                {labelName}
              </Form.Label>
              <Form.Control
                type="text"
                id="modalInput"
                name="newName"
                placeholder={name}
                value={values.newName}
                autoFocus
                onChange={handleChange}
                isInvalid={touched.newName && !!errors.newName} />
              <Form.Control.Feedback type="invalid" style={{ marginLeft: "0px" }}>
                {errors.newName}
              </Form.Control.Feedback>
              {status && <Alert variant="danger">{status}</Alert>}
              <hr
                style={{ left: "-20px", position: "relative", width: "120%" }} />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "20px",
                }}
              >
                <Button
                  variant="secondary"
                  onClick={closeHandler}
                  disabled={isSubmitting}
                >
                  Close
                </Button>
                <Button variant="primary" type="submit" disabled={isSubmitting}>
                  Save
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export const ModalDeleteConfirmation = (
  show: boolean,
  name: string,
  deleteHandler: (id: number | undefined) => void,
  closeHandler: () => void,
  type: string
) => {
  return (
    <Modal show={show} onHide={closeHandler}>
      <Modal.Header closeButton>
        <Modal.Title>Delete {type}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete the "{name}" {type}?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeHandler}>
          Close
        </Button>
        <Button variant="danger" onClick={() => deleteHandler(undefined)}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
